import { Component, Input, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { PatientMainResponsibleView } from './models/patient-main-responsible-view.model';
import { PatientMainResponsiblesService } from './services/patient-main-responsibles.service';

@Component({
    selector: 'app-patient-main-responsibles',
    templateUrl: './patient-main-responsibles.component.html',
    styleUrls: ['./patient-main-responsibles.component.scss'],
    standalone: false
})
export class PatientMainResponsiblesComponent {
    private readonly patientMainResponsiblesService = inject(PatientMainResponsiblesService);

    @Input() public set patientId(value: string) {
        this.mainResponsibles$ = this.patientMainResponsiblesService.getMainResponsibles(value);
    }

    public mainResponsibles$: Observable<PatientMainResponsibleView[]>;
}
